var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#358C2A",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3066 5110 c-160 -20 -328 -71 -467 -140 -155 -78 -257 -156 -416 -317 -84 -85 -160 -153 -170 -153 -10 0 -71 32 -136 70 -66 39 -127 70 -137 70 -10 0 -26 -8 -36 -17 -14 -15 -16 -31 -11 -123 4 -58 14 -292 23 -520 17 -438 21 -460 65 -460 21 0 933 384 957 403 7 6 12 24 10 40 -3 27 -16 39 -108 97 -136 87 -137 92 -44 216 198 266 404 429 642 507 145 48 265 67 471 74 151 5 177 9 193 25 41 41 13 73 -100 117 -109 42 -240 79 -340 96 -106 19 -307 26 -396 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 3904 c-151 -32 -288 -131 -348 -251 -43 -85 -50 -127 -22 -146 20 -14 27 -13 78 7 55 20 75 21 612 26 l555 5 -3 180 c-2 99 -6 183 -8 187 -3 5 -184 8 -402 7 -300 0 -413 -4 -462 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2984 3908 c-12 -5 -30 -28 -40 -50 -37 -81 -87 -118 -265 -192 -183 -76 -212 -92 -206 -109 3 -9 202 -13 818 -17 l814 -5 66 -27 c112 -48 123 -39 117 94 -4 76 -9 103 -31 145 -32 63 -82 115 -140 145 -42 23 -43 23 -577 25 -360 1 -542 -1 -556 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 3260 c-88 -22 -160 -82 -196 -163 l-24 -52 0 -1410 0 -1410 24 -52 c26 -58 90 -123 148 -150 36 -17 132 -18 1842 -21 1993 -3 1863 -7 1953 61 28 21 54 54 76 96 l32 64 0 308 c0 194 -4 318 -11 336 -29 77 -98 112 -220 113 -278 0 -529 183 -612 445 -32 101 -32 319 0 420 83 262 334 445 612 445 122 1 191 36 220 113 7 18 11 143 11 337 l0 308 -33 63 c-20 40 -48 75 -75 96 -88 67 41 63 -1931 62 -982 -1 -1799 -5 -1816 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3962 2014 c-113 -30 -212 -117 -253 -222 -18 -46 -23 -77 -23 -157 0 -122 23 -190 90 -264 54 -60 113 -96 190 -116 84 -22 574 -22 659 0 116 30 212 118 255 232 18 49 21 74 18 163 -3 96 -6 112 -36 172 -52 106 -144 176 -261 198 -85 16 -575 12 -639 -6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/Credit.c800fee0675c75576d57283e9cb6c3a8.svg";
export { ForwardRef as ReactComponent };